"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ClaimNoPublishersPopup = ({ closeModal }) => (react_1.default.createElement(Popup_1.default, { onClose: closeModal },
    react_1.default.createElement("h2", null, "No eligible publisher found."),
    react_1.default.createElement("p", null, "You are not authorized to alter any existing shares on this work. To continue with your claim, please add a publisher and/or administrator in order to assign shares."),
    react_1.default.createElement("div", { className: "button-row" },
        react_1.default.createElement(Button_1.Button, { mainColor: true, type: "primary", onClick: closeModal }, "Okay"))));
exports.default = ClaimNoPublishersPopup;
